<template>
  <div class="app-main-content">
    <h1>Page not found</h1>
    <RiDmvHome />
  </div>
</template>

<script setup>
import appConfig from '@/app.config'
import RiDmvHome from "@/components/RiDmvHome";
import { useHead } from '@unhead/vue';

defineOptions({
  name: 'PageNotFound',
})

// Use unhead to manage the page meta
useHead({
  title: `Page Not Found | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: 'The page you are looking for does not exist.'
    }
  ]
})
</script>